type Props = {
  values: {
    label: string;
    value: number;
  }[];
};

export const Description = ({ values }: Props) => {
  return (
    <div className='flex flex-col items-center gap-[64px] py-16'>
      <div className='flex max-w-[916px] flex-col items-center gap-8'>
        <p className='text-title-strong-medium__sp lg:text-title-strong-medium'>レポートページ</p>
        <p className='px-4 text-body-large lg:px-0'>
          このレポートページでは、「社会をより良く変えていきたい」という想いを持った方々（ココロイキルヒト）が生み出す活動やインパクトを集約し、東北ソーシャルイノベーションの今をお伝えします。全てのデータや活動報告は本レポートの趣旨に賛同した社会起業家たちによりリアルタイムに更新されています。
        </p>
      </div>
      <div className='flex flex-col items-center justify-center gap-6 lg:flex-row'>
        {values.map(({ value, label }, i) => (
          <div className='flex w-[240px] flex-col items-center gap-2' key={i}>
            <p className='!text-[56px] text-en-title-strong-large font-bold leading-[70px] text-accent'>
              {value.toLocaleString()}
            </p>
            <p className='text-body-strong-large'>{label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
